import { render } from "./PageLayoutForms.vue?vue&type=template&id=0a2b936f&scoped=true"
import script from "./PageLayoutForms.vue?vue&type=script&lang=js"
export * from "./PageLayoutForms.vue?vue&type=script&lang=js"

import "./PageLayoutForms.vue?vue&type=style&index=0&id=0a2b936f&lang=scss"
import "./PageLayoutForms.vue?vue&type=style&index=1&id=0a2b936f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2b936f"]])

export default __exports__